import axios from "axios"
import authAction from "core/store/actions/authAction"
import { store } from "../../store"
import jwtDecode from "jwt-decode"
import loaderAction from "core/store/actions/loaderAction"
import { fetchAuthSession } from "aws-amplify/auth"


const getToken = async () => {
  try {
    const token: any = sessionStorage.getItem("accessToken")
    let decoded = { exp: 0 }
    decoded = jwtDecode(token)

    const decodedTime = decoded?.exp * 1000
    const tokenTime = new Date(decodedTime)
    const currentTime = new Date()
    currentTime.setMinutes(currentTime.getMinutes() + 1);

    if (tokenTime <= currentTime) {
      const refreshingToken = sessionStorage.getItem("refreshingToken")
      let forceRefresh = false
      if (refreshingToken !== "true") {
        sessionStorage.setItem("refreshingToken", "true")
        forceRefresh = true
      }

      const refreshedToken: any = await fetchAuthSession({ forceRefresh })

      const accessToken = refreshedToken?.tokens?.accessToken.toString();
      const idToken = refreshedToken?.tokens?.idToken?.toString();

      // Store tokens in session storage
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('idToken', idToken);
      if (refreshingToken !== "true") {
        sessionStorage.setItem("refreshingToken", "false")
      }

      const { dispatch } = store
      dispatch(authAction.setAccessToken(accessToken))
      return accessToken
    } else {
      return token
    }
  } catch (error) {
    console.error("Error acquiring refreshed token:", error)
    window.location.replace("/session-expiry")
    return null
  }
}

const generateHeaders = async (headers = {}) => {
  try {
    const token = await getToken()
    if (!token) {
      return headers
    }
    const currentRole = sessionStorage.getItem("currentRole")
    const currentCenter = sessionStorage.getItem("currentCenter")
    const currentUserId = sessionStorage.getItem("currentUserId")

    const configObj: any = {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": null,
      "Cache-Control": "no-store",
      ...headers,
    }

    if (currentRole && currentRole !== "null") {
      configObj["x-current-role"] = currentRole
    }
    if (currentCenter && currentCenter !== "null") {
      configObj["x-current-center"] = currentCenter
    }
    if (currentUserId && currentUserId !== "null") {
      configObj["x-current-user-id"] = currentUserId
    }

    return configObj
  } catch (error) {
    console.error("Error generating headers:", error)
    return headers
  }
}

export const apiHelper = axios.create({
  timeout: 30000,
})

apiHelper.interceptors.request.use(async (config) => {
  try {
    config.headers = await generateHeaders(config.headers)
    const { dispatch } = store
    dispatch(loaderAction.incrementLoadingCounter())

    return config
  } catch (error) {
    console.error("Request interceptor error:", error)
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())
    return Promise.reject(error)
  }
})

apiHelper.interceptors.response.use(
  (value) => {
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())

    return Promise.resolve(value)
  },
  (error: any) => {
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())

    return Promise.reject(error)
  }
)

export const apiHelperCS = axios.create({
  timeout: 30000,
})

apiHelperCS.interceptors.request.use(async (config) => {
  try {
    config.headers = await generateHeaders(config.headers)
    const { dispatch } = store
    if (!config.params.skipLoader) {
      dispatch(loaderAction.incrementLoadingCounter())
    }
    return config
  } catch (error) {
    console.error("Request interceptor error:", error)
    const { dispatch } = store
    if (!config.params.skipLoader) {
      dispatch(loaderAction.decrementLoadingCounter())
    }
    return Promise.reject(error)
  }
})

apiHelperCS.interceptors.response.use(
  (value) => {
    const { dispatch } = store
    if (!value.config.params.skipLoader) {
      dispatch(loaderAction.decrementLoadingCounter())
    }
    return Promise.resolve(value)
  },
  (error: any) => {
    const { dispatch } = store
    if (!error.config.params.skipLoader) {
      dispatch(loaderAction.decrementLoadingCounter())
    }
    return Promise.reject(error)
  }
)

export const apiUnauthenticatedHelper = axios.create({
  timeout: 30000,
})

apiHelper.interceptors.request.use(async (config) => {
  try {
    const { dispatch } = store
    dispatch(loaderAction.incrementLoadingCounter())

    return config
  } catch (error) {
    console.error("Request interceptor error:", error)
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())
    return Promise.reject(error)
  }
})

apiHelper.interceptors.response.use(
  (value) => {
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())

    return Promise.resolve(value)
  },
  (error: any) => {
    const { dispatch } = store
    dispatch(loaderAction.decrementLoadingCounter())

    return Promise.reject(error)
  }
)